<template>
	<div class="article card" :class="article.section.toLowerCase()">
		<img
				class="card-img ratio ratio-1x1"
				@load="console.log(`image ${article.slug} loaded`)"
				:src="article.images[0]"
			/>
		<div class="card-img-overlay">
			<div class="details">
				<DetailsComponent :article="article"/>
			</div>
		</div>
	</div>
</template>

<script setup>
import DetailsComponent from './publications/DetailsComponent.vue';

const props = defineProps(["article"]);
</script>
